import { useIsFeatureEnabledQuery } from '../network/queries/useIsFeatureEnabledQuery';
import { useUser } from './useUser';

type FeatureAccessOptions = {
  requireOrganizationOwner?: boolean;
  /**
   * When false, the underlying feature-flag query is skipped (no network
   * request) and the feature resolves as disabled. Use for flags that are
   * only meaningful when another condition (e.g. a parent flag) holds.
   */
  enabled?: boolean;
};

type FeatureAccessParams = {
  featureId: string;
  options?: FeatureAccessOptions;
};

export const useFeatureAccess = ({
  featureId,
  options = {},
}: FeatureAccessParams) => {
  const { requireOrganizationOwner = false, enabled = true } = options;
  const { isOrganizationOwner, isLoading: isUserLoading } = useUser();
  const { data, isLoading, isError } = useIsFeatureEnabledQuery(featureId, {
    enabled,
  });

  const isEnabled = enabled && !!data;
  const meetsOrgOwnerRequirement =
    !requireOrganizationOwner || !!isOrganizationOwner;

  return {
    isEnabled,
    canAccess: isEnabled && meetsOrgOwnerRequirement,
    isLoading: isLoading || isUserLoading,
    isError,
    isOrganizationOwner: !!isOrganizationOwner,
  };
};
